import React, { useState, useEffect, useRef } from 'react';
import { Button, Spin, message, Pagination, Empty, Popover } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { DownloadOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import NewMessage from '../../component/newMessage/newMessage';
import UploadDocumentModal from './uploadDocumentModal';
import './keyDocument.css'
import moment from 'moment';
import upload from '../../public/img/newMain/upload.png'
import submit2 from '../../public/img/newMain/submit2.png'
import deleteblue from '../../public/img/newMain/deleteblue.png'
import replaceblue from '../../public/img/newMain/replaceblue.png'
import DeleteFileModal from './deleteFileModal';
import SubmitFileModal from './submitFileModal';
import UploadConfirmModal from './uploadConfirmModal';
import { studentCheckLogin } from '../newMain/studentMain';

const KeyDocument = (props) => {

    const studentModuleId = localStorage.getItem(Config.tokenPrefix + 'studentModuleId');
    const [studentModuleModel, setStudentModuleModel] = useState({});

    const [isLoad, setIsLoad] = useState(false);
    const deleteFileMessageRef = useRef();
    const submitFileMessageRef = useRef();
    const submitFileSuccRef = useRef();
    const [isUploadDocumentModal, setIsUploadDocumentModal] = useState(false);
    const [formData, setFormData] = useState(false);
    const uploadConfirmRef = useRef();

    const [pageSize, setPageSize] = useState(9);
    const [current, setCurrent] = useState(1);
    const [tablesCount, setTablesCount] = useState(0);
    const [tables, setTables] = useState([]);
    const [keyDocumentModel, setKeyDocumentModel] = useState({});
    const [editFlag, setEditFlag] = useState({});

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        searchModuleById();
        search(pageSize, current);
    }, []);

    
    const searchModuleById = () => {
        let model = {studentModuleId: studentModuleId};
        model.studentId = Config.studentInfo?.studentId;
        Base.callBackApi("studentModule/searchById", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data?.object ?? {};
                setStudentModuleModel(model);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const search = (pageSizeNew, currentNew) => {
        let model = {studentModuleId: studentModuleId, studentId : Config.studentInfo?.studentId};
        model.pageSize = pageSizeNew;
        model.startRow = (currentNew - 1) * pageSizeNew;
        model.page = currentNew;
        Base.callBackApi("keyDocument/search", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                setTablesCount(data?.object?.count)
                setTables(data?.object?.list ?? [])
                setCurrent(currentNew);
                setPageSize(pageSizeNew);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const onChange = (currentNew, pageSizeNew) => {
        document.getElementById("container").scrollTop = 0;
        search(pageSizeNew, currentNew);
    }

    const openUploadDocument = (flag, model) => {
        setEditFlag(flag);
        setKeyDocumentModel(model);
        setIsUploadDocumentModal(true)
    }

    const closeUploadDocument = (flag, formData) => {
        setIsUploadDocumentModal(false)
        if (flag) {
            setFormData(formData);
            uploadConfirmShow();
        }
    }

    const uploadConfirm = (flag) => {
        uploadConfirmRef.current.setIsShow(false)
        if (flag) {
            if (isLoad) {
                return;
            }
            let url = 'keyDocument/insert';
            if (editFlag === 'edit') {
                url = 'keyDocument/update';
            }
            setIsLoad(true);
            Base.callBackUploadApi(url, formData).then((data) => {
                if ("SUCCESS" === data.msg) {
                    submitFileSuccShow("You have successfully uploaded the selected Key Document. Its status will be set to Draft. Please note that you will need to press “Submit” to officially submit the Key Document.")
                } else {
                    message.error(data.msg)
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const uploadConfirmShow = () => {
        uploadConfirmRef.current.setContent("Please confirm that you wish to upload the selected Key Document. ")
        uploadConfirmRef.current.setIsShow(true)
    }

    const download = (model) => {
        if (!Base.stopClick()) {
            return;
        }
        Base.downloadFile(Config.keyDocument + model.filePath + '?' + Config.sasToken, model.fileName);
    }

    const submitFileSucc = () => {
        submitFileSuccRef.current.setIsShow(false);
        search(pageSize, 1);
    }

    const submitFileSuccShow = (msg) => {
        submitFileSuccRef.current.setContent(msg)
        submitFileSuccRef.current.setIsShow(true)
    }

    const deleteFile = (flag) => {
        deleteFileMessageRef.current.setIsShow(false)
        if (flag) {
            setIsLoad(true);
            Base.callBackApi("keyDocument/delete", keyDocumentModel).then((data) => {
                if ("SUCCESS" === data.msg) {
                    submitFileSuccShow("You have deleted the selected Key Document successfully.")
                } else {
                    message.error(data.msg)
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const deleteFileShow = (model) => {
        setKeyDocumentModel(model);
        deleteFileMessageRef.current.setContent("Please confirm that you wish to delete the selected Key Document.")
        deleteFileMessageRef.current.setIsShow(true)
    }

    const submitFile = (flag) => {
        submitFileMessageRef.current.setIsShow(false)
        if (flag) {
            setIsLoad(true);
            Base.callBackApi("keyDocument/updateStatus", keyDocumentModel).then((data) => {
                if ("SUCCESS" === data.msg) {
                    submitFileSuccShow("You have submitted the selected Key Document successfully.")
                } else {
                    message.error(data.msg)
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const submitFileShow = (model) => {
        setKeyDocumentModel(model);
        submitFileMessageRef.current.setContent("Please confirm that you wish to submit the selected Key Document. This action cannot be undone.")
        submitFileMessageRef.current.setIsShow(true)
    }

    return (
        <div id="container" className='websiteTemplate keyDocument'>
            <DeleteFileModal ref={deleteFileMessageRef} done={deleteFile} />
            <UploadConfirmModal ref={uploadConfirmRef} done={uploadConfirm} />
            <SubmitFileModal ref={submitFileMessageRef} done={submitFile} />
            <NewMessage ref={submitFileSuccRef} done={submitFileSucc} />
            {isUploadDocumentModal && <UploadDocumentModal onClose={closeUploadDocument} keyDocumentModel={keyDocumentModel} editFlag={editFlag} />}
            <Spin size="large" spinning={isLoad} >
                <div className='topBox'>
                    <div className='websiteSysButtonRow'>
                        <div className="detailTitle labelCircleBox">
                            Key Documents
                            <Popover placement="right" content={<div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                                This section is to record Key documents in their Final status, for purpose of future Reference/Audit. There is a limit of 15 documents and max 5MB each.
                            </div>} trigger="hover">
                                <div className='labelCircle'><InfoCircleOutlined /></div>
                            </Popover>
                        </div>
                    </div>
                    <div className='moduleBox'>
                        <div className='moduleBoxCenter'>
                            <div>
                                <div className='cardSubTitle'>{studentModuleModel?.moduleCode}</div>
                                <div className='cardSubTitle'>{studentModuleModel?.moduleName}</div>
                                <div className='flexBox'>
                                    <div className='label'>Student Name</div>
                                    <div className='value'>{studentModuleModel?.firstName && studentModuleModel?.lastName && studentModuleModel?.firstName + ' ' + studentModuleModel?.lastName}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Student ID</div>
                                    <div className='value'>{studentModuleModel?.studentAcctId}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Programme</div>
                                    <div className='value'>{studentModuleModel?.progTitle}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Cohort Year</div>
                                    <div className='value'>{studentModuleModel?.cohortYear}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Assigned Academic Supervisor</div>
                                    <div className='value'>{studentModuleModel?.academicSupervisorUserName}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Module Convener</div>
                                    <div className='value'>{studentModuleModel?.moduleConvenerName}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Student Record Status</div>
                                    <div className='value'>{ContextHandler.getMapValue('studentModuleStatusMap', studentModuleModel?.status)}</div>
                                </div>
                            </div>
                            <div>
                                <div className='countTitleBox'>
                                    <div className='cardSubTitle'>WIL Hours</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>Total Curriculum Hours</div>
                                    <div className='value '>{studentModuleModel?.curriculumHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>Other Learning Activities Hours</div>
                                    <div className='value '>{studentModuleModel?.otherLearningTrainingHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>WIL Hours Exempted</div>
                                    <div className='value '>{studentModuleModel?.exemptedHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>WIL Hours Needed</div>
                                    <div className='value '>{studentModuleModel?.neededWilHours}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>WIL Hours Completed</div>
                                    <div className='value '>{studentModuleModel?.completedWilHours} ({studentModuleModel?.neededWilHours > 0 ? Base.parseToPercent(studentModuleModel?.completedWilHours / studentModuleModel?.neededWilHours) : 100}%)</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of WPA in progress</div>
                                    <div className='value '>{studentModuleModel?.inProgressWpaCount}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of WPA status Sent to IP that is over 14 days</div>
                                    <div className='value '>{studentModuleModel?.sentToIsCount}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of WPA Completed</div>
                                    <div className='value '>{studentModuleModel?.completedWpaCount}</div>
                                </div>
                            </div>
                            <div>
                                <div className='countTitleBox'>
                                    <div className='cardSubTitle'>Assignments</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'># of Assignments submitted vs. target</div>
                                    <div className='value '>{studentModuleModel?.studentModuleAssignModelList ? studentModuleModel?.studentModuleAssignModelList?.filter(item => item.status == 'SUBMITTED')?.length + '/' + studentModuleModel?.studentModuleAssignModelList?.length : '0/0'}</div>
                                </div>
                                <div className='countTitleBox'>
                                    <div className='cardSubTitle'>Marks</div>
                                </div>
                                {studentModuleModel?.studentModuleAssignModelList?.map(item =>
                                    <div className='flexBox ' key={item?.studentModuleAssignId}>
                                        <div className='label'>{item?.assignName} mark</div>
                                        <div className='value '>{item?.assignMarks == 0 ? '0/100' : (item?.assignMarks ? Base.parseToFixed(item?.assignMarks, 2) + '/100' : 'Incomplete')}</div>
                                    </div>
                                )}
                                <div className='flexBox '>
                                    <div className='label'>Total WPA mark</div>
                                    <div className='value '>{studentModuleModel?.wpaMarks == 0 ? '0/100' : (studentModuleModel?.wpaMarks ? Base.parseToFixed(studentModuleModel?.wpaMarks, 2) + '/100'  : 'N/A')}</div>
                                </div>
                                <div className='flexBox '>
                                    <div className='label'>Total Module Mark and grade</div>
                                    <div className='value '>{studentModuleModel?.totalModuleMark == 0 ? '0/100' : (studentModuleModel?.totalModuleMark ? Base.parseToFixed(studentModuleModel?.totalModuleMark, 2) + '/100 (' + Base.calcGrade(studentModuleModel?.totalModuleMark) + ')' : 'N/A')} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="websiteSysButtonBox">
                        <div onClick={() => openUploadDocument('add', {studentModuleId: studentModuleId})} className='websiteSysButton uploadButton'><img src={upload} />Upload New Key Document(s)</div>
                    </div>
                </div>
                {Base.isEmpty(tables) ? <Empty /> : ''}
                <div className='seeAllCardBox'>
                    {tables?.map((item, index) =>
                        <div key={index} className={'allCardBoxDiv borderColor' + item.status}>
                            <div className='cardTitleBox'>
                                <div className='cardTitle' title={item.fileTypeVal}>{item.fileTypeVal}</div>
                                <div className={'statusBox ' + item.status}>
                                    {ContextHandler.getMapValue('KeyDocumentStatusMap', item.status)}
                                </div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>{item?.fileTypeVal2}</div>
                                <div className='value'></div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Uploaded File</div>
                                <div className='value'>{item.fileName}</div>
                            </div>
                            <div className='flexBox'>
                                <div className='label'>Submitted Date</div>
                                <div className='value'>{item.submittedDate ? moment(item.submittedDate).format(Config.dateFormatEn) : ''}</div>
                            </div>
                            <div className='cardLine'></div>
                            <div className='cardButtonBox' >
                                <Button className='cardButton' onClick={() => download(item)}><DownloadOutlined />Download</Button>
                                {item.status === 'DRAFT' &&
                                    <>
                                        <Button onClick={() => openUploadDocument('edit', item)} icon={<img src={replaceblue} />} className='cardButton'>Replace</Button>
                                        <Button onClick={() => deleteFileShow(item)} icon={<img src={deleteblue} />} className='cardButton'>Delete</Button>
                                        <Button onClick={() => submitFileShow(item)} icon={<img src={submit2} />} className='cardButton'>Submit</Button>
                                    </>
                                }
                            </div>
                        </div>
                    )}
                </div>
                {tablesCount > 9 && <div className="pagination">
                    <Pagination defaultCurrent={1}
                        current={current}
                        pageSize={9}
                        total={tablesCount}
                        itemRender={itemRender}
                        showSizeChanger={false}
                        onChange={onChange}
                    />
                </div>}
            </Spin>
        </div>
    )

}

export default KeyDocument;